export default {
    API_BASE: process.env.VUE_APP_API_BASE,
    APP_GETCARBON_CO_BASE: process.env.VUE_APP_APP_GETCARBON_CO_BASE,
    MAIN_URL: 'https://getcarbon.co/',
    CUSTOMER_SUCCESS_BASE: "https://customersuccess.getcarbon.co/portal/api",
    CUSTOMER_SUCCESS_PORTAL_ID: "edbsn5d515ec3f7558702839abc2d4c9575a2b0d4d612f68ff4461c5a614ed065964a"
}
